export default __webpack_public_path__ + "static/media/Girl-smartphone.8371060f.png";